export function roundToDecimal(number: number, decimalPlaces: number, toFloor = false) {
  const multiplier = Math.pow(10, decimalPlaces);
  if (toFloor) return Math.floor(number * multiplier) / multiplier;
  return Math.round(number * multiplier) / multiplier;
}
